const articles = [
  {
    id: 1,
    imgsrc: "/static/assets/nouveau.jpg",
    title: "Le nouveau site du BOP est en ligne",
    pubdate: "04/11/2018",
    taxonomy: ["Club"], tags: ["Site Web"], color: "rgba(0, 123, 224, 0.75)",
    summary: "Le nouveau site web du BOP est désormais en ligne. N'hésitez pas à nous faire vos retours !",
    fullhand: "",
    showFull: false,
    lien: "#",
    showImgTaxo: false
  },
  {
    id: 2,
    imgsrc: "/static/assets/resultats-we.jpg",
    title: "Les résultats du week-end",
    pubdate: "04/11/2018",
    taxonomy: ["Résultats"], tags: ["Matchs du Week-end"], color: "rgba(255, 0, 0, 0.75)",
    summary: "Résultats des matchs du samedi 24/10/2018 et du dimanche 25/11/2018.",
    fullhand: "", showFull: false, lien: "#"
  },
  {
    id: 3,
    imgsrc: "/static/assets/matchs-we.png",
    title: "Les matchs du week-end",
    pubdate: "03/11/2018",
    taxonomy: ["Agenda"], tags: ["Matchs du Week-end"], color: "rgba(255,69,0, 0.75)",
    summary: "Le calendrier des matchs samedi 24/10/2018 et du dimanche 25/11/2018 est disponible !",
    fullhand: "", showFull: false, lien: "#"
  },
  {
    id: 4,
    imgsrc: "/static/assets/fos-provence-logo.jpg",
    title: "Invitations rencontre ProA (Jeep-Elite) FOS-Provence-Basket / Bourg-en-Bresse",
    pubdate: "03/11/2018",
    taxonomy: ["Divers"], tags: ["ProA"], color: "rgba(0, 190, 0, 0.75)",
    summary: `Le BOP invite ses  licenciés à la rencontre de proA "FOS-Provence-Basket / Bourg-en-Bresse" à FOS-SUR-MER, le samedi 10/11/2018 à 20h30.
    Les inscriptions sont ouvertes!!! N'hésitez pas à contacter votre entraineur pour plus d'information concernant cette rencontre.`,
    fullhand: "", showFull: false, lien: "#"
  },
  {
    id: 5,
    imgsrc: "/static/assets/soiree-pizza.jpeg",
    title: "16/11/2018 - Soirée PIZZA organisée par le BOP dès 19h00",
    pubdate: "03/11/2018",
    taxonomy: ["Club"], tags: ["Détente"], color: "rgba(0, 123, 224, 0.75)",
    summary: "Le BOP organise une soirée pizza le vendredi 16 novembreau COSEC du Puy-Sainte-Réparade à partir de 19h00 ",
    fullhand: "", showFull: false, lien: "#"
  },
  {
    id: 6,
    imgsrc: "/static/assets/actus_bop/im8.jpg",
    title: "Voici un exemple d'article",
    pubdate: "03/11/2018",
    taxonomy: ["Divers"], tags: ["Exemple"], color: "rgba(0, 190, 0, 0.75)",
    summary: "Ceci est un extrait de l'article complet. Il convient de suivre le lien pour afficher un article complet.",
    fullhand: `
        <p>Il s’en est allé comme il a régné. A sa manière, et selon ses termes. C’est affalé sur un canapé juché sur le pont de son bateau, en marcel et short, lunettes noires vissées sur les yeux, que Boris Diaw a annoncé la fin de sa carrière, jeudi 6 septembre. <em>« C’est officiel les gars</em>.<em> »</em> Et <em>« les gars »</em> de le congratuler.</p>
        <p>Les gars ? Deux hommes rencontrés vingt ans plus tôt sur les bancs de l’INSEP. Deux amis, Tony Parker et Ronny Turiaf aux côtés desquels le tout frais retraité a <em>« écrit l’histoire du basket français »</em>.</p>
        <p>Dans une longue vidéo, les trois « frères » du basket hexagonal dissertent de la vie future du désormais ex-joueur. Si Parker, seul de la bande à faire encore carrière – il vient de signer pour deux ans aux Charlotte Hornets – évoque la <em>« possible petite mort »</em> que connaît un sportif le jour où il remise les baskets, Diaw l’évacue d’un sourire. Un sourire auquel les supporteurs français se sont accoutumés été après été, quand le capitaine du navire France endossait le maillot bleu.</p>
        <p><em>« Je ne vois pas ça comme une retraite, mais comme une nouvelle vie », </em>assure-t-il. Avant de poursuivre, lui qui a décidé de hisser les voiles pour entamer un tour du monde en bateau : <em>« j’ai tellement de passions qui vont me garder occupé, je me dis que c’est le moment. »</em></p>
        <p>Passionné, l’homme de 36 ans l’est. Outre la balle orange, Diaw croque la vie à pleines dents. Entrée-plat-dessert, et du bon vin pour accompagner. Gourmet et œnologue amateur, il tranche – physiquement, diront les mauvaises langues au fil des ans – avec certains de ses collègues aux rythmes d’ascète.</p>
        <p>Féru de voile – il a fait construire son catamaran – et de plongée, il s’est aussi tourné vers la photographie : depuis qu’en 2005 on lui a mis un appareil dans les mains, il consacre une semaine par an à un safari-photo. Il s’améliore, au point, après un stage avec l’un de leurs photographes à shooter des...</p>
        `,
    showFull: true,
    lien: "#"
  }
]

export default articles;



// WEBPACK FOOTER //
// ./src/store/news-articles.js